















import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { channelTypes } from "@/config/channels/channel-types.config.json";
import { channels as tv } from "@/config/host.config";
import { IContentType } from "@/@types/channels/content-type";

import ChannelTypesTabs from "@/components/app/tabs/channels/channel-types-tabs.vue";

@Component({
  components: { ChannelTypesTabs },
})
export default class ChannelsPage extends Vue {
  @Provide("channel_images") channel_images = "channels";

  activeType = channelTypes[0];
  contentTypes: Array<IContentType> = [];
  deletedContentType = false;

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }

  @Watch("deletedContentType")
  async createContentTypes(): Promise<void> {
    this.contentTypes = [];
    const uri = tv.content_type;
    const params = {
      "match[deleted][value]": this.deletedContentType,
    };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.contentTypes = res.data;
    } catch (error) {
      this.onError();
      console.error(error);
    }
  }

  mounted(): void {
    this.createContentTypes();
  }
}
